import { Language } from "@/components/Inputs/LanguagePicker/Language.ts";
import { URLParam } from "@/helpers/interfaces/URLParam.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import i18next from "i18next";
import { useMemo } from "react";

export const LanguagePicker = () => {
  const rootAttributes = useEngineStore((state) => state.rootAttributes);

  const hideLanguagePicker = useMemo(
    () => rootAttributes?.hide_language_picker,
    [rootAttributes.hide_language_picker],
  );

  if (hideLanguagePicker) return null;

  const handleLanguageChange = async (lang: string) => {
    await i18next.changeLanguage(lang);
    localStorage.setItem("i18nextLng", lang);
    const urlParams = new URLSearchParams(window.location.search);

    urlParams.set(URLParam.Language, lang);
    window.history.pushState({}, "", `${window.location.pathname}?${urlParams.toString()}`);
  };

  let languages = Object.values(Language);

  if (rootAttributes?.languages?.length) languages = rootAttributes.languages as Language[];

  return (
    <ul className="languagePickerWrap c-language-picker u-p1 u-uppercase">
      {languages?.map((lang, i) => (
        <li key={lang}>
          {i > 0 ? <span className="c-language-picker__separator"></span> : null}
          <button className="c-be-link" onClick={() => handleLanguageChange(lang)}>
            <span className="c-be-link__label">{lang?.toUpperCase()}</span>
          </button>
        </li>
      ))}
    </ul>
  );
};
